var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-row',[_c('van-col',{staticStyle:{"margin-top":"10px"},attrs:{"span":"9","offset":"1"}},[_c('span',[_vm._v("每月发送条数统计")])]),_c('canvas',{attrs:{"id":"recordMonthCount"}})],1),_c('van-row')],1)}
var staticRenderFns = []

export { render, staticRenderFns }